export enum MainGroupConfiguration {
    Sport = "Sport",
    League = "League",
    Day = "Day",
    Event = "Event"
}